import { render, staticRenderFns } from "./landingRobotics-var2.vue?vue&type=template&id=c90bbfac&scoped=true&"
import script from "./landingRobotics-var2.vue?vue&type=script&lang=js&"
export * from "./landingRobotics-var2.vue?vue&type=script&lang=js&"
import style0 from "./landingRobotics-var2.vue?vue&type=style&index=0&id=c90bbfac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90bbfac",
  null
  
)

export default component.exports